import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import type { SwitchProps } from '../index';

const H5Switch: React.FC<SwitchProps> = ({
    checked,
    onChange,
    disabled = false,
    className,
    'aria-label': ariaLabel,
}) => {
    const handleClick = () => {
        if (disabled) {
            return;
        }
        onChange?.(!checked);
    };

    return (
        <button
            type="button"
            className={classNames(
                styles.switch,
                checked && styles.switchChecked,
                disabled && styles.switchDisabled,
                className,
            )}
            onClick={handleClick}
            disabled={disabled}
            aria-pressed={checked}
            aria-label={ariaLabel}
        >
            <span className={styles.switchTrack} />
            <span className={styles.switchThumb} />
        </button>
    );
};

export default H5Switch;
